import React from 'react';
export function Footer() {
  return <footer className="bg-deep-blue text-white py-12" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center" data-id="element-20">
        <div className="mb-6 md:mb-0" data-id="element-21">
          <span className="text-2xl font-bold tracking-tight" data-id="element-22">
            IUL<span className="text-vitality-green" data-id="element-23">Seguro</span>
          </span>
          <p className="text-gray-400 text-sm mt-2" data-id="element-24">
            Protegiendo el futuro de las familias hispanas.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-sm text-gray-400" data-id="element-25">
          <a href="#" className="hover:text-white transition-colors" data-id="element-26">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-27">
            Términos y Condiciones
          </a>
          <span data-id="element-28">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </span>
        </div>
      </div>
    </footer>;
}